import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IServiceLocationInitialState } from "./serviceLocationModel";
import {
  getAllServiceLocation,
  getAllActiveServiceLocation,
  getServiceLocationByID,
  activeInactiveServiceLocation
} from "./services/serviceLocation.services";

const initialState: IServiceLocationInitialState = {
  ServiceLocationList: [],
  ServiceLocationDetails: null,
  ServiceLocationID: null,
  loading: false,
  error: null,
};

const serviceLocationSlice = createSlice({
  name: "serviceLocation",
  initialState,
  reducers: {
    setServiceLocationID: (state, action: PayloadAction<number | null>) => {
      state.ServiceLocationID = action.payload;
    },
    clearServiceLocationID: (state) => {
      state.ServiceLocationID = null;
    },
    clearServiceLocationDetails: (state) => {
      state.ServiceLocationDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getAllServiceLocation
      .addCase(getAllServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.ServiceLocationList = action.payload;
      })
      .addCase(getAllServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch service locations";
      })

      // getAllActiveServiceLocation
      .addCase(getAllActiveServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllActiveServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.ServiceLocationList = action.payload;
      })
      .addCase(getAllActiveServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch active service locations";
      })

      // getAllActiveServiceLocation
      .addCase(activeInactiveServiceLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(activeInactiveServiceLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.ServiceLocationList = action.payload;
      })
      .addCase(activeInactiveServiceLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch active service locations";
      })

      // getServiceLocationByID
      .addCase(getServiceLocationByID.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceLocationByID.fulfilled, (state, action) => {
        state.loading = false;
        state.ServiceLocationDetails = action.payload;
      })
      .addCase(getServiceLocationByID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch service location details";
      });
  },
});

export const {
  setServiceLocationID,
  clearServiceLocationID,
  clearServiceLocationDetails
} = serviceLocationSlice.actions;

export default serviceLocationSlice.reducer;
